module.exports = __webpack_public_path__ + "static/img/leftShop.a909c003.png";